import { render, staticRenderFns } from "./language.vue?vue&type=template&id=366af137&"
import script from "./language.vue?vue&type=script&lang=ts&"
export * from "./language.vue?vue&type=script&lang=ts&"
import style0 from "./language.vue?vue&type=style&index=0&id=366af137&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports